import React from 'react';
import { Row } from '../../lib/utils';

type Status = 'CONFIRMED' | 'COMPLETED' | 'NOSHOW';

const STATUS_CONFIG: Record<Status, { label: string; bg: string; color: string }> = {
    CONFIRMED: { label: '예약', bg: '#EFF6FF', color: '#2563EB' },
    COMPLETED: { label: '출석', bg: '#D1FAE5', color: '#065F46' },
    NOSHOW: { label: '노쇼', bg: '#FEE2E2', color: '#DC2626' },
};

const AttendanceToggle = ({
    status,
    onChange,
    disabled,
}: {
    status: Status;
    onChange: (status: Status) => void;
    disabled?: boolean;
}) => (
    <Row style={{ gap: 0, borderRadius: 6, overflow: 'hidden', border: '1px solid #E5E7EB' }}>
        {(['CONFIRMED', 'COMPLETED', 'NOSHOW'] as Status[]).map((s) => {
            const cfg = STATUS_CONFIG[s];
            const isActive = status === s;
            return (
                <button
                    key={s}
                    onClick={() => !disabled && onChange(s)}
                    style={{
                        padding: '4px 10px',
                        fontSize: 12,
                        fontWeight: isActive ? 600 : 400,
                        backgroundColor: isActive ? cfg.bg : 'white',
                        color: isActive ? cfg.color : '#9CA3AF',
                        border: 'none',
                        cursor: disabled ? 'default' : 'pointer',
                        transition: 'all 0.1s',
                    }}
                >
                    {cfg.label}
                </button>
            );
        })}
    </Row>
);

export default AttendanceToggle;
